// 2026-10-15：仅公共OSS目录封面使用Service Worker持久图片缓存；不读取跨域Blob或处理鉴权链接。
import {computed,onUnmounted,ref,watch,Ref} from 'vue'
const marker='__ld_cover_cache'
let registration:Promise<boolean>|undefined
export function publicCoverCacheUrl(source:string):string {
  try {
    const url=new URL(source)
    if(url.protocol!=='https:' || url.hostname!=='allfiles.landiyun.com' || url.port || url.username || url.password
      || !/^\/org-images\/[^?#]+\.(png|jpe?g|webp|gif|bmp)$/i.test(url.pathname)
      || !/^image\/resize,/.test(url.searchParams.get('x-oss-process') || ''))return source
    let protectedSource=false
    url.searchParams.forEach((_value,key)=>{if(/signature|credential|token|expires|access.?key|authorization|auth_?key/i.test(key))protectedSource=true})
    if(protectedSource)return source
    url.searchParams.set(marker,'1')
    return url.toString()
  }catch{return source}
}
export function ensureCoverCache():Promise<boolean>{
  if(registration)return registration
  if(typeof navigator==='undefined' || !('serviceWorker' in navigator) || !window.isSecureContext)return Promise.resolve(false)
  registration=(async()=>{
    try {
      const worker=new URL(`${process.env.BASE_URL || '/'}catalog-cover-worker.js`,window.location.origin)
      // 2026-10-15：新脚本更新不依赖HTTP旧缓存；仅图片fetch分支接管，其他请求继续浏览器原流程。
      await navigator.serviceWorker.register(worker.href,{scope:process.env.BASE_URL || '/',updateViaCache:'none'})
      if(navigator.serviceWorker.controller)return true
      return await new Promise<boolean>(resolve=>{
        const finish=()=>{clearTimeout(timer);navigator.serviceWorker.removeEventListener('controllerchange',changed);resolve(Boolean(navigator.serviceWorker.controller))}
        const changed=()=>finish(),timer=setTimeout(finish,5000)
        navigator.serviceWorker.addEventListener('controllerchange',changed)
        if(navigator.serviceWorker.controller)finish()
      })
    }catch{return false}
  })()
  return registration
}
export function useProductCoverCache(source:Ref<string>){
  const ready=ref(false),retryCount=ref(0),imageFailed=ref(false)
  let disposed=false
  void ensureCoverCache().then(value=>{if(!disposed)ready.value=value})
  onUnmounted(()=>{disposed=true})
  watch(source,()=>{imageFailed.value=false})
  const cachedCoverUrl=computed(()=>{
    const value=ready.value?publicCoverCacheUrl(source.value):source.value
    if(value===source.value || !retryCount.value)return value
    const url=new URL(value);url.searchParams.set('__ld_cover_retry',String(retryCount.value));return url.toString()
  })
  const evictCover=()=>{
    if(typeof navigator!=='undefined')navigator.serviceWorker?.controller?.postMessage({type:'LANDIYUN_COVER_EVICT',url:publicCoverCacheUrl(source.value)})
  }
  const retryCover=()=>{evictCover();retryCount.value++;imageFailed.value=false}
  return {cachedCoverUrl,evictCover,retryCover,imageFailed,coverAttempt:retryCount}
}
